// 根据环境引入不同配置
const environment = 'test'
const config = require('./env.' + environment)
module.exports = config